const isMicrosoft = organizationName => (
  organizationName?.toLowerCase() === "microsoft"
);

export default isMicrosoft;
